var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{attrs:{"id":_vm.chartId}}),_vm._t("c-actions",null,{"chart":_vm.chart,"data":_vm.chartData})],2)}
var staticRenderFns = []

export { render, staticRenderFns }